<div class="d-flex flex-column p-2">

    <app-search-filter>
        <div class="row">
            <div class="col-4">
                <label for="symbol" class="form-label font-12">نماد:</label>
                <app-symbol-search [isMulti]="true" (selectSearchSymbol)="selected($event)"></app-symbol-search>
            </div>

            <div class=" col-2">
                <label for="fiscalYear" class="form-label font-12">سال مالی:</label>
                <input type="input" class="form-control" id="fiscalYear" name="fiscalYear" [(ngModel)]="fiscalYear"
                    mask="0000" [allowNegativeNumbers]="false">
            </div>
            <div class=" col-2">
                <label for="reportMonth" class="form-label font-12"> ماه گزارش:</label>
                <input type="input" class="form-control" id="reportMonth" [(ngModel)]="reportMonth" name="reportMonth"
                    mask="0000" [allowNegativeNumbers]="false">
            </div>
            <div class="col-2">
                    <label for="tagStatus" class="form-label">وضعیت تگ:</label>
                    <select class="form-select" [(ngModel)]="tagStatus" id="tagStatus">
                        <option value="1">دارد</option>
                        <option value="2">ندارد</option>

                    </select>
            </div>
            <div class=" col-2 d-flex align-items-end justify-content-end">
                <button class="btn btn-primary btn-sm" (click)="searchTable()">جستجو</button>
            </div>
        </div>
    </app-search-filter>
    <hr class="my-4" />
    <!-- Table content -->

    <app-table [data]="nonOperationalIncomeList" [KeyName]="KeyName" [columnName]="columnName" [isLoading]="isLoading"
        [totalRecords]="totalRecords" [pageSize]="pageSize" [(page)]="page" (changePageEvent)="changePage($event)"
        (changeSizeEvent)="changeSize($event)" (sortEvent)="handleSort($event)" (clickOnRow)="openAddTagModal($event)">
    </app-table>
</div>